// ── Chart chrome ────────────────────────────────────────────────────────────
// The page registers no echarts theme, so each chart carries its own on-brand
// palette and neutral axes: emerald for the primary series, a muted steel for
// the companion series, and faint grid lines / axis text sized to stay legible
// on both the light and dark card surfaces.
// NOTE: comma-separated HSL, not the space-separated CSS Color 4 form — echarts'
// zrender parser can't read `hsl(h s% l%)`, so it fails to derive the hover
// (emphasis) colour and renders the hovered bar transparent (it disappears).
export const CHART_GREEN = 'hsl(160, 70%, 45%)'
export const CHART_STEEL = 'hsl(214, 22%, 60%)'
export const CHART_AXIS_TEXT = 'hsl(220, 6%, 58%)'
export const CHART_GRID_LINE = 'rgba(148, 163, 184, 0.14)'
export const CHART_AXIS_LINE = 'rgba(148, 163, 184, 0.22)'
export const CHART_AMBER = 'hsl(38, 92%, 55%)'
